class TestimonialsSlider {
  constructor(container) {
    this.container = container;
    this.grid = container.querySelector('.testimonials-cards__grid');
    this.cards = Array.from(this.grid.querySelectorAll('.testimonial-card'));
    this.currentSlide = 0;
    this.dotsContainer = null;
    this.isEnabled = false;
    
    this.init();
    this.handleResize();
    
    window.addEventListener('resize', () => this.handleResize());
  }
  
  init() {
    if (window.innerWidth <= 768) {
      this.enable();
    }
  }
  
  enable() {
    if (this.isEnabled) return;
    
    this.isEnabled = true;
    this.grid.classList.add('slider-enabled');
    this.createDots();
    this.updateSlider();
    this.addTouchSupport();
  }
  
  disable() {
    if (!this.isEnabled) return;
    
    this.isEnabled = false;
    this.grid.classList.remove('slider-enabled');
    this.grid.style.transform = '';
    
    if (this.dotsContainer) {
      this.dotsContainer.remove();
      this.dotsContainer = null;
    }
    
    this.currentSlide = 0;
  }
  
  createDots() {
    this.dotsContainer = document.createElement('div');
    this.dotsContainer.className = 'testimonials-dots';
    
    this.cards.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.className = 'testimonials-dot';
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      
      if (index === 0) {
        dot.classList.add('active');
      }
      
      dot.addEventListener('click', () => this.goToSlide(index));
      this.dotsContainer.appendChild(dot);
    });
    
    this.container.appendChild(this.dotsContainer);
  }
  
  updateDots() {
    if (!this.dotsContainer) return;
    
    const dots = this.dotsContainer.querySelectorAll('.testimonials-dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentSlide);
    });
  }
  
  goToSlide(index) {
    if (index < 0 || index >= this.cards.length) return;
    
    this.currentSlide = index;
    this.updateSlider();
  }
  
  updateSlider() {
    const cardWidth = this.cards[0].offsetWidth;
    const gap = 35;
    // Calculate offset without gap for the last slide
    const offset = this.currentSlide === this.cards.length - 1 
      ? -(this.currentSlide * cardWidth + (this.currentSlide) * gap)
      : -(this.currentSlide * (cardWidth + gap));
    
    this.grid.style.transition = 'transform 0.3s ease';
    this.grid.style.transform = `translateX(${offset}px)`;
    this.updateDots();
  }
  
  addTouchSupport() {
    let startX = 0;
    let startY = 0;
    let currentX = 0;
    let currentY = 0;
    let isDragging = false;
    let initialOffset = 0;
    
    this.grid.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = true;
      
      // Get current transform value
      const transform = this.grid.style.transform;
      const match = transform.match(/translateX\((.+)px\)/);
      initialOffset = match ? parseFloat(match[1]) : 0;
      
      // Disable transition during drag
      this.grid.style.transition = 'none';
    });
    
    this.grid.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      
      currentX = e.touches[0].clientX;
      currentY = e.touches[0].clientY;
      
      const diffX = currentX - startX;
      const diffY = currentY - startY;
      
      // Only handle horizontal swipes
      if (Math.abs(diffX) > Math.abs(diffY)) {
        e.preventDefault();
        
        // Apply drag with boundaries
        const newOffset = initialOffset + diffX;
        const maxOffset = 0;
        const minOffset = -(this.cards[this.cards.length - 1].offsetWidth * (this.cards.length - 1) + 35 * (this.cards.length - 1));
        
        // Limit dragging beyond boundaries
        const boundedOffset = Math.max(minOffset, Math.min(maxOffset, newOffset));
        this.grid.style.transform = `translateX(${boundedOffset}px)`;
      }
    }, { passive: false });
    
    this.grid.addEventListener('touchend', () => {
      if (!isDragging) return;
      
      const diff = startX - currentX;
      const threshold = 50;
      
      if (Math.abs(diff) > threshold) {
        if (diff > 0 && this.currentSlide < this.cards.length - 1) {
          this.goToSlide(this.currentSlide + 1);
        } else if (diff < 0 && this.currentSlide > 0) {
          this.goToSlide(this.currentSlide - 1);
        } else {
          // Snap back to current slide
          this.updateSlider();
        }
      } else {
        // Snap back to current slide
        this.updateSlider();
      }
      
      isDragging = false;
    });
  }
  
  handleResize() {
    if (window.innerWidth <= 768) {
      if (!this.isEnabled) {
        this.enable();
      } else {
        this.updateSlider();
      }
    } else {
      this.disable();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.testimonials-cards');
  if (container) {
    new TestimonialsSlider(container);
  }
});
